<template>
    <button class="btn btn-primary" @click="sendModify()" v-if="state">
      Modifier
    </button>
    <button class="btn btn-primary" @click="sendSave()" v-else>
      Enregistrer
    </button>
</template>

<script>
  export default {
    props: {
      state: Boolean,
    },
    methods: {
      sendModify () {
        this.$emit('modify')
      },
      sendSave () {
        this.$emit('save')
      },
    },
  }
</script>



// WEBPACK FOOTER //
// ModifySaveButton.vue?7a94b2fe